import { reaction, computed, action, observable } from 'mobx';
import { RouterStore } from '@estee/elc-router';

export const NAVIGATE = 'navigate';

import { DEFAULT_ROUTE, QRCODE_ROUTE } from '../../routes';

import { events, emit, watchQuery } from '@estee/elc-service-bus';

export type storageKeyType = 'localStorage' | 'sessionStorage';
export interface IPersistentStorage {
    getItem(key: string): string | null | undefined;
    setItem(key: string, value: string, storageKey?: storageKeyType): void;
    removeItem(key: string): void;
}

export interface ICheckoutConfig {
    routerStore: RouterStore;
    persistentStorage: IPersistentStorage;
}

export interface IStringMap {
    [key: string]: string;
}

export class RampStore {
    private registerWatchers: Function;
    public routerStore: RouterStore;
    public persistentStorage: IPersistentStorage;

    constructor(checkoutConfig: ICheckoutConfig) {
        this.registerWatchers();
        this.routerStore = checkoutConfig.routerStore;
        this.persistentStorage = checkoutConfig.persistentStorage;

        reaction(() => this.isAuthenticated, this.onAuthChanged);
    }

    @watchQuery()
    @observable
    public isAuthenticated: boolean = false;

    public onAuthChanged = async () => {
        const { urlRedirectOnSuccess } = this.routerStore.queryParams;
        if (urlRedirectOnSuccess) {
            return;
        }
    };

    public goToExternalUrl = (route: string) => {
        this.routerStore.changeLocation(route);
    };

    public goToThankYouPage = () => {
        this.routerStore.changeCurrentRoute(QRCODE_ROUTE);
    };

    public onSessionExpired = () => {
        emit(events.SESSION_EXPIRED);
        this.routerStore.changeCurrentRoute(DEFAULT_ROUTE);
    };

    @computed
    get orderTestFlag() {
        const orderTestFlag = this.persistentStorage.getItem('orderTestFlag');

        return orderTestFlag === 'true' || orderTestFlag === '1';
    }

    @action
    public handleSubmitError = (error: {}) => {
        console.error(error);
        throw error;
    };

    public destroy() {
        this.routerStore.destroy();
    }
}
